<!-- App Main Structure -->
<template>
  <main class="app-horizontal-layout" aria-live="assertive" :aria-busy="session_ready ? 'false' : 'true'">
    <template v-if="!session_ready">
      <preloader />
    </template>
    <template v-else>
      <Login />
    </template>
  </main>
</template>

<script>
import { mapGetters } from 'vuex'
import Preloader from '@/components/Common/Preloader'
import Login from './../../components/Auth/Login'

export default {
  name: 'LoginView',
  components: {
    Login,
    Preloader,
  },
  computed: {
    ...mapGetters(['routerAnimation', 'session_ready']),
  }
}
</script>

<style scoped>
  .app-horizontal-layout {
    height: 100vh;
  }
</style>
